import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createUrl } from '../utils/url';
import BasicLink from './BasicLink';

const mapStateToProps = ({
  session,
  location: { baseURL }
}) => ({
  isAuthenticated: session.isAuthenticated,
  baseURL
});

const SignInLink = ({
  isAuthenticated, baseURL, location, children, ...props
}) => {
  const signInPath = `/sign/in/?routeTo=${createUrl(baseURL, location)}`;
  return !isAuthenticated
    ? <BasicLink to={signInPath} external {...props}>{children}</BasicLink>
    : null;
};

export default connect(mapStateToProps, null)(withRouter(SignInLink));



// WEBPACK FOOTER //
// ./src/universal/ui/components/SignInLink.js